import { Button, Card, Col, Form, Input, message, Row, Tabs } from "antd";
import React, { useEffect } from "react";
import { updateSettingsLimit } from "../../api/SettingApi";

const customerTypeLabels = {
  1: "Program 1",
  2: "Program 2",
  3: "Program 3",
};

export default function LimitSettings({ limitData = [], fetchSettings }) {
  const [form] = Form.useForm();

  // Load data into form when limitData changes
  useEffect(() => {
    if (limitData.length > 0) {
      // Set initial values with customerType as key
      const initialValues = {};
      limitData.forEach((item) => {
        initialValues[item.customerType] = item;
      });
      form.setFieldsValue(initialValues);
    }
  }, [limitData, form]);

  const saveAll = async () => {
    try {
      const values = await form.validateFields();

      // Convert form values back into array
      const payload = Object.keys(values).map((key) => ({
        ...values[key],
        customerType: Number(key), // ensure correct type
      }));

      console.log("payload", payload);

      await updateSettingsLimit(payload);
      fetchSettings();
      message.success("All limit settings saved successfully");
    } catch (err) {
      message.error("Validation failed");
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Tabs>
        {limitData.map((item) => (
          <Tabs.TabPane
            tab={customerTypeLabels[item.customerType]}
            key={item.customerType}
          >
            <Row gutter={24}>
              {/* Transaction Amount Limits */}
              <Col xs={24} md={12}>
                <Card title="Transaction Amount Limits" bordered>
                  <Form.Item
                    name={[item.customerType, "id"]}
                    initialValue={item.id}
                    hidden
                  >
                    <Input type="hidden" />
                  </Form.Item>
                  <Form.Item
                    name={[item.customerType, "maxPerTransaction"]}
                    label="Maximum per Single Transaction"
                    rules={[{ required: true, message: "Enter limit" }]}
                  >
                    <Input type="number" min={1} />
                  </Form.Item>
                  <Form.Item
                    name={[item.customerType, "maxPerDay"]}
                    label="Maximum Amount per Day"
                    rules={[{ required: true, message: "Enter limit" }]}
                  >
                    <Input type="number" min={1} />
                  </Form.Item>
                  <Form.Item
                    name={[item.customerType, "maxPerWeek"]}
                    label="Maximum Amount per Week"
                    rules={[{ required: true, message: "Enter limit" }]}
                  >
                    <Input type="number" min={1} />
                  </Form.Item>
                  <Form.Item
                    name={[item.customerType, "maxPerMonth"]}
                    label="Maximum Amount per Month"
                    rules={[{ required: true, message: "Enter limit" }]}
                  >
                    <Input type="number" min={1} />
                  </Form.Item>
                </Card>
              </Col>

              {/* Count & Balance Limits */}
              <Col xs={24} md={12}>
                <Card bordered>
                  <Row gutter={24}>
                    {/* Count Limits */}
                    <Col span={12}>
                      <Form.Item
                        name={[item.customerType, "maxTransactionsPerDay"]}
                        label="Max Transactions per Day"
                        rules={[{ required: true, message: "Enter count" }]}
                      >
                        <Input type="number" min={1} />
                      </Form.Item>
                      <Form.Item
                        name={[item.customerType, "maxTransactionsPerWeek"]}
                        label="Max Transactions per Week"
                        rules={[{ required: true, message: "Enter count" }]}
                      >
                        <Input type="number" min={1} />
                      </Form.Item>
                      <Form.Item
                        name={[item.customerType, "maxTransactionsPerMonth"]}
                        label="Max Transactions per Month"
                        rules={[{ required: true, message: "Enter count" }]}
                      >
                        <Input type="number" min={1} />
                      </Form.Item>
                    </Col>

                    {/* Wallet Balance Limits */}
                    <Col span={12}>
                      <Form.Item
                        name={[item.customerType, "maxTotalBalance"]}
                        label="Maximum Total Balance"
                        rules={[{ required: true, message: "Enter balance" }]}
                      >
                        <Input type="number" min={1} />
                      </Form.Item>
                      <Form.Item
                        name={[item.customerType, "warningThreshold"]}
                        label="Warning Threshold"
                        rules={[{ required: true, message: "Enter threshold" }]}
                      >
                        <Input type="number" min={1} />
                      </Form.Item>
                      <Form.Item
                        name={[item.customerType, "minRequiredBalance"]}
                        label="Minimum Required Balance"
                        rules={[
                          { required: true, message: "Enter min balance" },
                        ]}
                      >
                        <Input type="number" min={0} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Tabs.TabPane>
        ))}
      </Tabs>

      {/* Global Save Button */}
      <Row justify="end" style={{ marginTop: 20 }}>
        <Col>
          <Button type="primary" onClick={saveAll}>
            Save All Limits
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
